import { BreadcrumbsModule } from './shared/breadcrumbs/breadcrumbs.module';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgModule } from '@angular/core';
import { PageLayoutModule } from './shared/page-layout/page-layout.module';
import { PageModule } from './shared/page/page.module';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SidebarModule } from './shared/sidebar/sidebar.module';
import { TitleModule } from './shared/title/title.module';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationDialogModule } from './shared/notification-dialog/notification-dialog.module';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [
    BreadcrumbsModule,
    TitleModule,
    PageModule,
    SidebarModule,
    RouterModule,
    PageLayoutModule,

    // External
    FlexLayoutModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule,
    FontAwesomeModule,
    ScrollingModule,
    TranslateModule,
    NotificationDialogModule,
  ],
})
export class SharedModule {}
